import { Card, Box, Icon, Text } from '@nimbus-ds/components';
import { ChevronRightIcon, LocationIcon } from '@nimbus-ds/icons';
import { ProductTransferDetailsResponseDto } from '@tiendanube/common';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

type Location = ProductTransferDetailsResponseDto['originLocation'];

interface SourceDestinationCardProps {
  sourceLocation: Location;
  destinationLocation: Location;
}

function SourceDestinationCard({
  sourceLocation,
  destinationLocation,
}: Readonly<SourceDestinationCardProps>) {
  const t = useTranslationCatalog();

  return (
    <Card>
      <Card.Header title={t('transfers.detail.sourceDestination.title')} />
      <Card.Body>
        <Box
          display="flex"
          gap="4"
          alignItems="flex-start"
          flexDirection={{ xs: 'column', md: 'row' }}
        >
          <Location
            location={sourceLocation}
            label={t('transfers.new.sourceDestination.source.label')}
          />
          <Box alignSelf="center" display={{ xs: 'none', md: 'block' }}>
            <Icon source={<ChevronRightIcon />} color="neutral-textLow" />
          </Box>
          <Location
            location={destinationLocation}
            label={t('transfers.new.sourceDestination.destination.label')}
          />
        </Box>
      </Card.Body>
    </Card>
  );
}

function Location({
  location,
  label,
}: Readonly<{ location: Location; label: string }>) {
  return (
    <Box display="flex" gap="2" flex="1" flexDirection="column">
      <Text fontSize="caption" color="neutral-textLow">
        {label}
      </Text>
      <Box display="flex" gap="2">
        <Icon
          color="neutral-textHigh"
          source={<LocationIcon />}
          cursor="pointer"
        />
        <Text
          fontSize="highlight"
          lineHeight="highlight"
          color="neutral-textLow"
        >
          {location.name}
        </Text>
      </Box>
      <Text fontSize="caption">{location.address}</Text>
    </Box>
  );
}

export default SourceDestinationCard;
